import {
  SHOW_SUCCESS_SNACKBAR,
  HIDE_SNACKBAR,
  SHOW_WARNING_SNACKBAR,
  SHOW_ERROR_SNACKBAR,
  SHOW_INFO_SNACKBAR,
} from "./actionTypes";

export const hideSnackbar = () => ({
  type: HIDE_SNACKBAR,
});

export const successSnackbar = (payload) => async (dispatch) => {
  dispatch(hideSnackbar());

  setTimeout(() => {
    dispatch({
      type: SHOW_SUCCESS_SNACKBAR,
      payload:{
        ...payload,
        autoCloseDuration: payload.duration || 5000,
      }
    });
  }, 100);
};

export const warningSnackbar = (payload) => async(dispatch) => {
  dispatch(hideSnackbar());

  setTimeout(()=>{
    dispatch({
    type: SHOW_WARNING_SNACKBAR,
    payload:{
        ...payload,
        autoCloseDuration: payload.duration || 5000,
      }
  });
  },100)
};

export const errorSnackbar = (payload) => async(dispatch) => {
  dispatch(hideSnackbar());
  setTimeout(()=>{
    dispatch({
    type: SHOW_ERROR_SNACKBAR,
    payload:{
        ...payload,
        autoCloseDuration: payload.duration || 5000,
      }
  });
  },100)
};

export const infoSnackbar = (payload) => (dispatch) => {
  dispatch(hideSnackbar());
  setTimeout(()=>{
    dispatch({
    type: SHOW_INFO_SNACKBAR,
    payload:{
        ...payload,
        autoCloseDuration: payload.duration || 5000,
      }
  });
  },100)
};
